import { render, staticRenderFns } from "./HealthCare.vue?vue&type=template&id=41962996&scoped=true"
import script from "./HealthCare.vue?vue&type=script&lang=js"
export * from "./HealthCare.vue?vue&type=script&lang=js"
import style0 from "./HealthCare.vue?vue&type=style&index=0&id=41962996&prod&lang=css"
import style1 from "./HealthCare.vue?vue&type=style&index=1&id=41962996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41962996",
  null
  
)

export default component.exports